import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem, PrimeIcons } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { ProfileEnum } from '@/providers/enums/profile-Enum';
import { AuthService } from 'src/services/auth.service';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    providers: [AuthService],
    template: `<ul class="layout-menu">
        @for (item of model; track item.label; let i = $index) {
        <ng-container>
            @if(item.separator) {                
                <li class="menu-separator"></li>
            } @else {                
                <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
            }
        </ng-container>
        }
    </ul> `
})
export class AppMenu implements OnInit {

    private readonly authService = inject(AuthService);

    model: MenuItem[] = [];
    profile: ProfileEnum = ProfileEnum.Administrador;
    userName: string = "";

    constructor(private readonly contextService: AuthService) {
        this.profile = this.contextService.getUserPerfil();
        this.userName = this.contextService.getUsername();
    }

    ngOnInit() {
        this.model = [
            {
                label: 'Home',
                visible: this.isViewDashboard() || this.isAdmin(),
                items: [
                    {
                        label: 'Dashboard',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/app/dashboard'],
                        visible: this.isViewDashboard() || this.isAdmin(),
                    }
                ],
            },
            {
                label: 'CRM',
                items: [
                    {
                        label: "Leads",
                        icon: PrimeIcons.CHART_LINE,
                        routerLink: '/app/crm/dashboard',
                        visible: !this.isMarketing(),
                    },
                    {
                        label: "Cadastro",
                        icon: PrimeIcons.FILE_EDIT,
                        routerLink: '/app/crm/cadastro',
                        visible: this.isAdminAndSellerAndSellerExternal(),
                    },
                    {
                        label: "Relatórios",
                        icon: PrimeIcons.FILE,
                        routerLink: '/app/crm/relatorios',
                        visible: this.isAdmin(),
                    },
                    {
                        label: "Campanhas de Leads",
                        icon: PrimeIcons.TAGS,
                        routerLink: '/app/crm/campanhas-leads/lista',
                        visible: this.isAdmin() || this.isMarketing(),
                    },
                    {
                        label: "Roleta de Leads",
                        icon: PrimeIcons.SYNC,
                        routerLink: '/app/crm/roleta-leads/lista',
                        visible: this.isAdmin(),
                    },
                ],
                visible: this.isAdminAndSellerAndSellerExternal() || this.isFinancialManager() || this.isFormalizationManager() || this.isMarketing(),
            },
            {
                label: 'Sistema',
                items: [
                    // {
                    //     label: 'Estoque',
                    //     icon: PrimeIcons.CHART_LINE,
                    //     routerLink: '/app/estoque',
                    //     visible: this.isViewStock() || this.isAdmin(),
                    // },
                    {
                        label: 'Usuários',
                        icon: PrimeIcons.USERS,
                        routerLink: '/app/usuario/lista',
                        visible: this.isAdmin(),
                    },
                    {
                        label: 'Usuário',
                        icon: PrimeIcons.USER,
                        items: [
                            {
                                label: "Clientes",
                                icon: PrimeIcons.USERS,
                                routerLink: '/app/cliente/lista',
                                visible: this.isAdmin() || this.isViewClients(),
                            },
                            {
                                label: "Vendedores",
                                icon: PrimeIcons.USERS,
                                routerLink: '/app/usuario/lista',
                                visible: this.isViewSellers(),
                            },
                            {
                                label: "Comissão",
                                icon: PrimeIcons.MONEY_BILL,
                                routerLink: '/app/vendedor/comissao',
                                visible: this.isAdmin() || this.isFinancialManager() || this.isConsultManagerSellers(),
                            },
                            {
                                label: "Veículos",
                                icon: PrimeIcons.CAR,
                                routerLink: '/app/checkin/lista',
                                visible: true,
                            },
                            // {
                            //     label: "Ferramentas",
                            //     icon: PrimeIcons.WRENCH,
                            //     routerLink: '/app/ferramentas/lista',
                            //     visible: this.isViewTools() || this.isAdmin(),
                            // },
                        ],
                        visible: true,
                    },
                    {
                        label: 'Clientes',
                        icon: PrimeIcons.USERS,
                        items: [
                            {
                                label: `Fluxo de Processos`,
                                icon: PrimeIcons.ANGLE_DOUBLE_RIGHT,
                                routerLink: '/app/cliente/fluxo-processos',
                                visible: this.isViewFlow() || this.isAdmin(),
                            },
                            {
                                label: `Repescagem`,
                                icon: PrimeIcons.TIMES_CIRCLE,
                                routerLink: '/app/cliente/reprovados',
                                visible: this.isViewTables() || this.isAdmin(),
                            },
                            {
                                label: `O.S's`,
                                icon: PrimeIcons.COPY,
                                routerLink: '/app/cliente/os/lista',
                                visible: this.isViewOss() || this.isAdmin(),
                            },
                            {
                                label: `O.S's Preventivas`,
                                icon: PrimeIcons.COPY,
                                routerLink: '/app/cliente/os-preventiva/lista',
                                visible: this.isViewOss() || this.isAdmin(),
                            },
                            {
                                label: "Projetos",
                                icon: PrimeIcons.TABLE,
                                routerLink: '/app/cliente/projeto-cliente/lista',
                                visible: this.isViewProjects() || this.isAdmin(),
                            },
                            {
                                label: "Rastreios",
                                icon: PrimeIcons.TRUCK,
                                routerLink: '/app/cliente/rastreios',
                                visible: this.isAdmin() || this.isViewTrackings() || this.isDriverOrDelivery(),
                            },
                        ],
                        visible:
                            this.isViewFlow() ||
                            this.isViewOss() ||
                            this.isViewProjects() ||
                            this.isDriverOrDelivery() ||
                            this.isAdmin(),
                    },
                    {
                        label: "Sistema",
                        icon: PrimeIcons.COG,
                        items: [
                            // {
                            //     label: "Tabelas",
                            //     icon: PrimeIcons.FILE_PDF,
                            //     routerLink: "/app/configuracoes/tabela",
                            //     visible: this.isViewTables() || this.isAdmin(),
                            // },
                            {
                                label: "Notificações",
                                icon: PrimeIcons.INFO_CIRCLE,
                                routerLink: "/app/configuracoes/notificacoes",
                                visible: this.isAdmin(),
                            },
                            {
                                label: "Relatórios",
                                icon: PrimeIcons.FILE,
                                items: [
                                    {
                                        label: "Vendas",
                                        icon: PrimeIcons.DOLLAR,
                                        routerLink: "/app/configuracoes/relatorio/vendas",
                                    },
                                ],
                                visible:
                                    this.isViewDashboard() ||
                                    this.isAdmin() ||
                                    this.isViewReports(),
                            },
                            {
                                label: "Ajuste Fluxo",
                                icon: PrimeIcons.FILE,
                                routerLink: "/app/configuracoes/ajuste-fluxo",
                                visible: this.isAdmin()
                            },
                            {
                                label: "QR Codes",
                                icon: PrimeIcons.QRCODE,
                                routerLink: "/app/configuracoes/qrcode",
                                visible: this.isAdmin()
                            },
                            {
                                label: "Campanhas Marketing",
                                icon: PrimeIcons.WALLET,
                                routerLink: "/app/configuracoes/campanhas-marketing",
                                visible: this.isAdmin() || this.isFinancialManager()
                            },
                            {
                                label: "Rastreios em Andamento",
                                icon: PrimeIcons.TRUCK,
                                routerLink: "/app/configuracoes/rastreios-andamento",
                                visible: this.isAdmin()
                            },
                            {
                                label: "Roleta de Vendas",
                                icon: PrimeIcons.SYNC,
                                routerLink: "/app/configuracoes/roleta-vendas",
                                visible: this.isAdmin()
                            },
                        ],
                        visible:
                            this.isViewTables() ||
                            this.isViewDashboard() ||
                            this.isAdmin() ||
                            this.isFinancialManager() ||
                            this.isViewReports(),
                    },
                    { label: "Meu perfil", icon: PrimeIcons.USER, routerLink: "/app/usuario/perfil" },
                    { label: "Suporte", icon: PrimeIcons.QUESTION_CIRCLE, routerLink: "/app/suporte/lista" },
                    { label: 'Sair', icon: PrimeIcons.POWER_OFF, command: () => this.logout() }
                ]
            },
        ];
    }

    isAdmin() {
        return this.profile == ProfileEnum.Administrador;
    }

    isDriverOrDelivery() {
        return this.profile == ProfileEnum.Motorista || this.profile == ProfileEnum.Entregador;
    }

    isMarketing() {
        return this.profile == ProfileEnum.Marketing;
    }

    isViewTrackings() {
        return this.profile == ProfileEnum.GerenteDeSuporte;
    }

    isConsultManagerSellers() {
        return this.profile == ProfileEnum.GerenteDeVendas;
    }

    isAdminAndSellerAndSellerExternal() {
        return (
            this.profile == ProfileEnum.Administrador ||
            this.profile == ProfileEnum.GerenteDeVendas ||
            this.profile == ProfileEnum.SupervisorDeVendas ||
            this.profile == ProfileEnum.GerenteDeFormalizacao ||
            this.profile == ProfileEnum.ConsultorDeVendas ||
            this.profile == ProfileEnum.ConsultorDeVendasInterno
        );
    }

    isFinancialManager() {
        return this.profile == ProfileEnum.GerenteFinanceiro;
    }

    isFormalizationManager() {
        return this.profile == ProfileEnum.GerenteDeFormalizacao;
    }

    isCliente() {
        return this.profile == ProfileEnum.Cliente;
    }

    isViewDashboard() {
        return (
            this.profile == ProfileEnum.GerenteDeFormalizacao ||
            this.profile == ProfileEnum.GerenteDeVendas ||
            this.profile == ProfileEnum.SupervisorDeVendas ||
            this.profile == ProfileEnum.Marketing ||
            this.profile == ProfileEnum.GerenteFinanceiro
        );
    }

    isViewFlow() {
        return this.profile == ProfileEnum.GerenteDeSuporte ||
            this.profile == ProfileEnum.GerenteDeVendas ||
            this.profile == ProfileEnum.SupervisorDeVendas ||
            this.profile == ProfileEnum.GerenteDeFormalizacao ||
            this.profile == ProfileEnum.GerenteDeEstoque ||
            this.profile == ProfileEnum.GerenteDeProjetos ||
            this.profile == ProfileEnum.ConsultorDeVendas ||
            this.profile == ProfileEnum.GerenteFinanceiro
    }

    isViewStock() {
        return this.profile == ProfileEnum.GerenteDeEstoque ||
            this.profile == ProfileEnum.GerenteFinanceiro;
    }

    isViewReports() {
        return this.profile == ProfileEnum.GerenteDeProjetos ||
            this.profile == ProfileEnum.GerenteFinanceiro;
    }

    isViewTools() {
        return (
            this.profile == ProfileEnum.GerenteDeEstoque ||
            this.profile == ProfileEnum.GerenteDeSuporte ||
            this.profile == ProfileEnum.GerenteFinanceiro
        );
    }

    isViewSellers() {
        return (
            this.profile == ProfileEnum.GerenteDeFormalizacao ||
            this.profile == ProfileEnum.GerenteDeProjetos
        );
    }

    isViewTables() {
        return (
            this.profile == ProfileEnum.GerenteDeFormalizacao ||
            this.profile == ProfileEnum.GerenteDeVendas ||
            this.profile == ProfileEnum.SupervisorDeVendas ||
            this.profile == ProfileEnum.ConsultorDeVendas ||
            this.profile == ProfileEnum.ConsultorDeVendasInterno ||
            this.profile == ProfileEnum.GerenteFinanceiro
        );
    }

    isViewClients() {
        return (
            this.profile == ProfileEnum.GerenteDeVendas ||
            this.profile == ProfileEnum.SupervisorDeVendas ||
            this.profile == ProfileEnum.ConsultorDeVendas ||
            this.profile == ProfileEnum.ConsultorDeVendasInterno ||
            this.profile == ProfileEnum.Tecnico ||
            this.profile == ProfileEnum.GerenteDeProjetos ||
            this.profile == ProfileEnum.GerenteDeSuporte ||
            this.profile == ProfileEnum.GerenteDeFormalizacao ||
            this.profile == ProfileEnum.GerenteFinanceiro
        );
    }

    isViewOss() {
        return (
            this.profile == ProfileEnum.GerenteDeSuporte ||
            this.profile == ProfileEnum.GerenteDeProjetos ||
            this.profile == ProfileEnum.Tecnico ||
            this.profile == ProfileEnum.Montador ||
            this.profile == ProfileEnum.GerenteDeEstoque ||
            this.profile == ProfileEnum.GerenteFinanceiro
        );
    }

    isViewProjects() {
        return (
            this.profile == ProfileEnum.GerenteDeProjetos ||
            this.profile == ProfileEnum.GerenteDeSuporte ||
            this.profile == ProfileEnum.GerenteDeFormalizacao ||
            this.profile == ProfileEnum.GerenteDeEstoque ||
            this.profile == ProfileEnum.GerenteFinanceiro
        );
    }

    logout() {
        this.authService.logout();
    }
}
